// topAnime：topのアニメーション

export default function topAnime() {
  var $cardCont = $('.js-cardCont');
  var $cardItem = $cardCont.find('li');
  var animeFlag = sessionStorage.getItem('animeFlag');

  if (!($cardCont[0]) || $('body').hasClass('is-sp') || animeFlag === 'false') return;

  $cardCont.addClass('is-show');

  // カードが表示されたら
  $cardCont.on('animationend', function(evt) {
    // transition終了時の処理
    if($(this).hasClass('is-hidden')) return;
    setTimeout(function(){
      cardDisplay();
    },300);
    setTimeout(function(){
      cardOpen();
    },1800);
  });

  // 最後のカードが表になったら
  $cardItem.filter(":last").on('transitionend animationend', function() {
    if(!($(this).hasClass('is-open'))) return;
    setTimeout(function(){
      cardHidden();
      setTimeout(function(){
        endClass();
      },800);
    },500);

  });

  // 各カードの表示
  function cardDisplay() {
    $cardCont.find('li[data-pos="outer"]').addClass('is-display');
    setTimeout(function(){
        $cardCont.find('li[data-pos="inner"]').addClass('is-display');
    },30);
    setTimeout(function(){
        $cardCont.find('li[data-pos="center"]').addClass('is-display');
    },40);
  }
  // 各カードをまとめる
  function cardHidden() {
    $cardCont.find('li[data-pos="outer"]').removeClass('is-display');
    setTimeout(function(){
        $cardCont.find('li[data-pos="inner"]').removeClass('is-display');
    },30);
    setTimeout(function(){
        $cardCont.find('li[data-pos="center"]').removeClass('is-display');
    },40);
  }

  // カードの反転
  function cardOpen() {
    $cardItem.each(function(i) {
      $(this).delay(100 * i).queue(function(){
        $(this).addClass('is-open');
      });
    });
  }

  // アニメーション後にクラス付与（タイミングはcssで記載）
  function endClass() {
    $cardItem.addClass('is-hidden');
    $('.js-heroInner').addClass('is-show');
    $('.js-heroInfo').addClass('is-show');
    // アニメーションoff
    sessionStorage.setItem('animeFlag', 'false')
  }
}


// WEBPACK FOOTER //
// ./js/module/topAnime.js